export const team24 = [{
  "year": 2024,
  "CoreTeam": [
    {
      "Position": "Chairperson",
      "Name": "N. Siddarth Reddy",
      
      "ImgPath": "chair.jpg"
    },
    {
      "Position": "Vice Chairperson",
      "Name": "N. Sravya",
      
      "ImgPath": "vc.jpg"
    },
    {
      "Position": "Secretary",
      "Name": "N. Varun Gopal",
      
      "ImgPath": "gs.jpg"
    },
    {
      "Position": "Treasurer",
      "Name": "B. Krishna Sai",
      
      "ImgPath": "tresurer.jpg"
    },
    {
      "Position": "Membership Chair",
      "Name": "M. Praneetha",
      
      "ImgPath": "mem.jpg"
    },
    {
      "Position": "Webmaster",
      "Name": "S. Chandrakethan",
      
      "ImgPath": "webmaster.jpg"
    },
    {
      "Position": "Activities Coordinator",
      "Name": "K. Sai Harsha",
      
      "ImgPath": "tech.jpg"
    }
  ],
  "TeamHeads": [
    {
      "Position": "Social Media Head",
      "Name": "Srinibha Srikanth",
      
      "ImgPath": "sm.jpg"
    },
    {
      "Position": "Events & PR Head",
      "Name": "B. Aashritha",
     
      "ImgPath": "pr.jpg"
    },
    {
      "Position": "Technical Head",
      "Name": "K. Sai Harsha",
      
      "ImgPath": "tech.jpg"
    },
    {
      "Position": "Design Team Head",
      "Name": "M. Lalitha Bhavana",
      
      "ImgPath": "design.jpg"
    },
    {
      "Position": "Coding Team Head",
      "Name": "K. Tanuja",
      
      "ImgPath": "coding.jpg"
    },
    {
      "Position": "Creative Team Head",
      "Name": "R. Sai Aditya",
      
      "ImgPath": "creative.jpg"
    }
  ],
  "Volunteers": [
  {
    "Name": "Kannaiahgari Sai Manish",
    "Mail": "kannaiahgarimanish@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Cheeti Rishika",
    "Mail": "rishikacheeti14@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Abhinav Sai Janipireddy",
    "Mail": "abhinavsai.janipireddy@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Meghana Mekala",
    "Mail": "meghanaaravindmekala@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Balmoori Shriya",
    "Mail": "shriyarao1512@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Bakka Bhavani",
    "Mail": "bhavanibakka1903@gmail.com",
    "Team": "Social media",
    "LinkedIn": ""
  },
  {
    "Name": "Bhanu",
    "Mail": "saibhanupalla564@gmail.com",
    "Team": "Creative",
    "LinkedIn": ""
  },
  {
    "Name": "Akhil Aaditya Santosh Nalam",
    "Mail": "aaditya10012004@gmail.com",
    "Team": "Creative",
    "LinkedIn": ""
  },
  {
    "Name": "Akhil",
    "Mail": "akhil@gmail.com",
    "Team": "Creative",
    "LinkedIn": ""
  },
  {
    "Name": "Shashank Reddy",
    "Mail": "shashankreddy@gmail.com",
    "Team": "Creative",
    "LinkedIn": ""
  },
  {
    "Name": "Lakshita",
    "Mail": "laksita2004@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Taraka Kiranmayi",
    "Mail": "tarakakiranmayi@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Siddartha Samisetty",
    "Mail": "samisettysiddartha2004@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "K. Sathwik Reddy",
    "Mail": "sathwikreddy154@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Ch. Anand",
    "Mail": "anandch119@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Ronak Agrawal",
    "Mail": "reactoutron@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Sirikonda Gangothri",
    "Mail": "sirikondagangothri186@gmail.com",
    "Team": "Technical",
    "LinkedIn": ""
  },
  {
    "Name": "Vibha Bhat",
    "Mail": "vibha.shrinath@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Viramallu Sanjana",
    "Mail": "sanjanaviramallu@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Rithika Rayapudi",
    "Mail": "rithikarayapudi@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Abhilash Moturi",
    "Mail": "moturiabhilash@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Korla Prathyusha",
    "Mail": "prathyushakorla2004@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Poladi Renuka",
    "Mail": "renukapoladi5@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Puli Anvitha",
    "Mail": "anvithapuli2005@gmail.com",
    "Team": "Events and PR",
    "LinkedIn": ""
  },
  {
    "Name": "Mandala Sree Harshini",
    "Mail": "sreeharshinimandala@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "Panyala Shivalini Reddy",
    "Mail": "panyalashivalini14@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "Nani Gunji",
    "Mail": "nanigunji44@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "Kancherla Swathi",
    "Mail": "swatikancherla6@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "Vaishnavi Bejgam",
    "Mail": "vaishnavibejgam55555@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "K. Vaibhava Lakshmi",
    "Mail": "kuchurvaibhavalakshmi@gmail.com",
    "Team": "Design",
    "LinkedIn": ""
  },
  {
    "Name": "B. Tejaswini",
    "Mail": "tejuchowdary2004@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "K. Sai Harsha Vardhan",
    "Mail": "harshaspartax18@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "Kaviti Tanuja",
    "Mail": "tanukaviti2003@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "N. Sravya Reddy",
    "Mail": "sravyareddy.n06@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "N. Vamshi",
    "Mail": "nasanivamshivamshi@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "N. Varun Gopal",
    "Mail": "varungopalneela@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "A. Mahesh Reddy",
    "Mail": "akkulurimaheshreddy@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "Challa Vyshnavi Reddy",
    "Mail": "chvry03@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  },
  {
    "Name": "Pranay Thangellapalli",
    "Mail": "pranaythangellapally1029@gmail.com",
    "Team": "Coding",
    "LinkedIn": ""
  }
]

}
]